import { RaceShield } from "@/components/race-shield"
import { getRaceDisplayName, getRaceHue } from "@/lib/race-colors"
import { getRaceTraits } from "@/lib/race-traits"

interface RaceSpotlightCardProps {
  race: string
  flavor: string
}

export function RaceSpotlightCard({ race, flavor }: RaceSpotlightCardProps) {
  const hue = getRaceHue(race)
  const traits = getRaceTraits(race)
  const neonDim = `oklch(0.50 0.15 ${hue})`

  return (
    <div
      className="group relative flex h-full flex-col items-center p-6 text-center transition-all duration-300"
      style={{
        background: "oklch(0.10 0.01 55)",
        boxShadow: `inset 1px 1px 0 oklch(0.20 0.01 55), inset -1px -1px 0 oklch(0.06 0.01 55), 0 2px 12px oklch(0 0 0 / 0.5)`,
      }}
    >
      {/* Hover glow border */}
      <div
        className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
        style={{
          boxShadow: `inset 0 0 16px ${neonDim}, 0 0 20px oklch(0 0 0 / 0.3)`,
        }}
      />

      <RaceShield race={race} size="md" />

      <h3
        className="font-display mt-3 text-base font-bold tracking-wider uppercase md:text-lg"
        style={{
          WebkitTextStroke: `0.5px oklch(0.2 0.008 240)`,
          paintOrder: "stroke fill" as const,
          textShadow: `1px 1px 0 oklch(0.80 0.30 ${hue} / 0.9), 2px 2px 0 oklch(0.80 0.30 ${hue} / 0.5), 3px 3px 0 oklch(0.80 0.30 ${hue} / 0.2)`,
          color: "oklch(0.95 0.01 80)",
        }}
      >
        {getRaceDisplayName(race)}
      </h3>

      {/* Trait badges */}
      <div className="mt-1.5 flex flex-wrap justify-center gap-1.5">
        {traits.map((trait) => (
          <span
            key={trait}
            className="font-display text-[10px] tracking-widest uppercase"
            style={{ color: "oklch(0.55 0.02 55)" }}
          >
            {trait}
          </span>
        ))}
      </div>

      {/* Flavor text */}
      <p
        className="mt-2.5 text-xs leading-relaxed"
        style={{ color: "oklch(0.72 0.02 80)" }}
      >
        {flavor}
      </p>
    </div>
  )
}
